import Gateway from './gateway';
import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import {
    TCreateNewRoleAPIParams,
    TGetAdminListingAPIParams,
    TGetAdminListingAPIResponse,
    TGetRoleListingAPIParams,
    TGetRoleListingAPIResponse,
    TEditRoleDetailsAPIParams,
    TGetUserDetailsAPIParams,
    TGetUserDetailsAPIResponse,
    TRoleFilter,
    TCreateNewAdminAPIParams,
    TEditAdminDetailsAPIParams,
    TExportAdminUserListingAPIResponse,
    TExportAdminRoleListingAPIResponse,
} from '~types/feat/admin';

export abstract class IAdminGateway extends Gateway {
    abstract getAdminListing(params: TGetAdminListingAPIParams): GatewayResponse<TGetAdminListingAPIResponse>;

    abstract getRoleListing(params: TGetRoleListingAPIParams): GatewayResponse<TGetRoleListingAPIResponse>;

    abstract createNewRole(params: TCreateNewRoleAPIParams): GatewayResponse<null>;

    abstract editRoleDetails(params: TEditRoleDetailsAPIParams): GatewayResponse<null>;

    abstract getUserDetails(params: TGetUserDetailsAPIParams): GatewayResponse<TGetUserDetailsAPIResponse>;

    abstract getAllRoles(params: ProtectedRoute): GatewayResponse<TRoleFilter[]>;

    abstract createNewAdmin(params: TCreateNewAdminAPIParams): GatewayResponse<null>;

    abstract editAdminDetails(params: TEditAdminDetailsAPIParams): GatewayResponse<null>;

    abstract exportAdminUserListing(params: ProtectedRoute): GatewayResponse<TExportAdminUserListingAPIResponse[]>;

    abstract exportAdminRoleListing(params: ProtectedRoute): GatewayResponse<TExportAdminRoleListingAPIResponse[]>;
}
